<script lang="ts" setup>
import { faEarthAmericas } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { TrackTarget } from '@/api';
import { useTracking } from '@/utilities/tracking.ts';

const props = withDefaults(
  defineProps<{
    url?: string | null;
    label?: string | null;
    target: TrackTarget;
    targetId: number;
    variant?: 'primary' | 'secondary' | 'link';
  }>(),
  { url: null, label: null, variant: 'primary' }
);

const { trackAction } = useTracking();
const { t } = useI18n();

const styles = computed(() => {
  switch (props.variant) {
    case 'secondary':
      return {
        anchor: 'border-ph-green-700 text-ph-green-700 hover:bg-ph-green-50 inline-block cursor-pointer rounded-lg border px-4 py-2',
        icon: 'text-ph-green-600 mr-2',
      };
    case 'link':
      return {
        anchor: 'text-ph-green-700 hover:text-ph-green-600 inline-block cursor-pointer text-sm font-medium underline underline-offset-2',
        icon: 'mr-1.5',
      };
    default:
      return {
        anchor: 'hover:bg-ph-green-600 bg-ph-green-700 inline-block cursor-pointer rounded-lg px-4 py-2 text-white',
        icon: 'text-ph-green-200 mr-2',
      };
  }
});

function onClick() {
  void trackAction(props.target, props.targetId, 'website');
}
</script>

<template>
  <a v-if="url && url.length > 0" :class="['no-print', styles.anchor]" :href="url" rel="sponsored noopener" target="_blank" @click="onClick">
    <FontAwesomeIcon :class="styles.icon" :icon="faEarthAmericas" />
    <span>{{ label ?? t('components.website-button.website') }}</span>
  </a>
</template>

<style lang="css" scoped></style>
